import { environment } from "../../environments/environment";

export class Urls {
  private static baseUri: string = environment.apiBaseUri;
  private static mainUri: string = environment.apiMainUri;

  static getMainApiInfo: string = `${Urls.baseUri}Info/version`;

  static getAllReferralForms: string = `${Urls.baseUri}ReferralForms/All`;
  static getAllReferralFormsWithoutChildren: string = `${Urls.baseUri}ReferralForms/AllWithoutChildren`;
  static updateReferralForm: string = `${Urls.baseUri}ReferralForms`;
  static getReferralFormQuestionGroups: string = `${Urls.baseUri}ReferralFormQuestionGroups/ReferralForm`;
  static createReferralForm: string = `${Urls.baseUri}ReferralForms`;
  static saveReferralForm: string = `${Urls.baseUri}ReferralForms`;
  static deleteReferralForm: string = `${Urls.baseUri}ReferralForms`;

  static getReferralFormById(referralFormId: number): string {
    return `${Urls.baseUri}ReferralForms/?id=${referralFormId}`;
  }

  static getAllReferralFormTypes: string = `${Urls.baseUri}ReferralFormTypes/All`;

  static getAllOptionTypes: string = `${Urls.baseUri}OptionTypes/All`;

  static getAllQuestionGroups: string = `${Urls.baseUri}QuestionGroups/All`;
  static getQuestionGroupById: string = `${Urls.baseUri}QuestionGroups/?id=`;
  static createQuestionGroup: string = `${Urls.baseUri}QuestionGroups/`;
  static updateQuestionGroup: string = `${Urls.baseUri}QuestionGroups/`;
  static deleteQuestionGroup: string = `${Urls.baseUri}QuestionGroups/?id=`;

  static getQuestionById: string = `${Urls.baseUri}Questions/?id=`;
  static getQuestions: string = `${Urls.baseUri}Questions/`;
  static createQuestion: string = `${Urls.baseUri}Questions/`;
  static updateQuestion: string = `${Urls.baseUri}Questions/`;
  static deleteQuestion: string = `${Urls.baseUri}Questions/`;
  static getQuestionTypes: string = `${Urls.baseUri}Questions/QuestionTypes`;

  static addQuestionToQuestionGroup: string = `${Urls.baseUri}QuestionGroupQuestions/`;
  static updateQuestionInQuestionGroup: string = `${Urls.baseUri}QuestionGroupQuestions/`;
  static deleteQuestionFromQuestionGroup(questionGroupId: number, questionId: number): string {
    return `${Urls.baseUri}QuestionGroupQuestions/QuestionGroup/${questionGroupId}/Question/${questionId}/`;
  }

  static getAllEmailTypes: string = `${Urls.baseUri}Email/GetAllEmailTypes`;
  static createEmailTemplate: string = `${Urls.baseUri}Email/Create`;
  static updateEmailTemplate: string = `${Urls.baseUri}Email/Update`;

  static getAllLetterTypes: string = `${Urls.baseUri}Letter/GetAllLetterTypes`;
  static createLetterTemplate: string = `${Urls.baseUri}Letter/Create`;
  static updateLetterTemplate: string = `${Urls.baseUri}Letter/Update`;

  static getAllTextMessageTypes: string = `${Urls.baseUri}TextMessage/GetAll`;
  static getTextMessageTemplateByTextMessageType(textMessageTypeId: number) {
    return `${Urls.baseUri}TextMessage/GetTextMessageTemplateByTextMessageTypeId/${textMessageTypeId}`;
  }
  static createTextMessageTemplate: string = `${Urls.baseUri}TextMessage/Create`;
  static updateTextMessageTemplate: string = `${Urls.baseUri}TextMessage/Update`;


  static getReferralFormByFormTypeId(formTypeId: number): string {
    return `${Urls.baseUri}ReferralForms/FormType/${formTypeId}`;
  }
  static getReferralFormsByVisitId(visitId: number): string {
    return `${Urls.baseUri}ReferralForms/FormsByVisitId/${visitId}`;
  }

  static getAllUserAccessRequests: string = `${Urls.baseUri}UserAccessRequests/All`;
  static : string = `${Urls.baseUri}UserAccessRequests/All`;

  static updateUser: string = `${Urls.baseUri}Users/`;
  static updateUserRole: string = `${Urls.baseUri}Users/UpdateUserRole`;
  static getAllPartnerUsers: string = `${Urls.baseUri}Users/Partners`;
  static getAllPartners: string = `${Urls.baseUri}Partners/All`;
  static getAllPartnerTypes: string = `${Urls.baseUri}Partners/GetAllPartnerTypes`;
  static getAllActivePartners: string = `${Urls.baseUri}Partners/AllActive`;
  static getAllVisitReferralDeletionReasons: string = `${Urls.baseUri}Partners/GetAllVisitReferralDeletionReasons`;
  static deleteReferral: string = `${Urls.baseUri}Partners/DeleteReferral`;

  static getPartnersForPartnerTypeEndPoint: string = `${Urls.baseUri}Partners/GetPartnersForPartnerType/`;

  static getReferralActionById(id: number): string {
    return `${Urls.baseUri}Partners/GetReferralActionById/${id}`;
  }
    
  static getUserAccessRequestById(id: number): string {
    return `${Urls.baseUri}UserAccessRequests/${id}`;
  }

  static getReferralFormByReferralFormId(referralFormId: number): string {
    return `${Urls.baseUri}ReferralForms/${referralFormId}`;
  }

  static getClaims(email: string): string {
    return `${Urls.mainUri}UserManagements/Users/${email}/Groups`;
  }

  static getUserByEmailId(email: string): string {
    return `${Urls.mainUri}Users/Email/${email}`;
  }

  static registerUserSignIn(email: string): string {
    return `${Urls.mainUri}Users/RegisterSignIn/${email}`;
  }

  static getActiveUserByEmailId(email: string): string {
    return `${Urls.mainUri}Users/Email/${email}/Active`;
  }

  static getEmailTemplateByEmailTypeId(emailTypeId: number) {
    return `${Urls.baseUri}Email/GetEmailTemplateByEmailTypeId/${emailTypeId}`;
  };
  static getLogoByEmailTypeId(emailTypeId: number) {
    return `${Urls.baseUri}Email/GetLogoByEmailTypeId/${emailTypeId}`;
  };
  static getSignatureByEmailTypeId(emailTypeId: number) {
    return `${Urls.baseUri}Email/GetSignatureByEmailTypeId/${emailTypeId}`;
  };
  static getLetterTemplateByLetterTypeId(letterTypeId: number) {
    return `${Urls.baseUri}Letter/GetLetterTemplateByLetterTypeId/${letterTypeId}`;
  };

  static checkIfLoggedInUserIsAdmin(email: string): string {
    return `${Urls.baseUri}Users/IsUserAdmin/${email}`;
  }

  static getUserById(id: string): string {
    return `${Urls.mainUri}Users/GetUserById/${id}`;
  }

  static getIsSrfsOrAdminUser(email: string): string {
    return `${Urls.mainUri}UserManagements/IsSrfsOrAdminUser/${email}`;
  }
  static getAllSrfsUsers: string = `${Urls.mainUri}UserManagements/AccessLevel/2/Users/All`;
  static getAllAdUsers: string = `${Urls.mainUri}UserManagements/Users/All`;

  static getAllUsers: string = `${Urls.mainUri}Users/All`;

  static getResources: string = `${Urls.baseUri}Resources/GetAll`;

  static deleteUserByEmailAndAccessLevel(email: string): string {
    return `${Urls.baseUri}Users/Email/${email}`;
  }

  static getAllUserRoles: string = `${Urls.mainUri}Users/UserRoles`;

  static getAllUserRolesForPartner(): string {
    return `${Urls.mainUri}Users/UserRolesForPartner`;
  }

  //UserRolesForUser
  static getNoteByNoteId(id: number): string {
    return `${Urls.baseUri}Notes/${id}`;
  }

  static createNote: string = `${Urls.baseUri}Notes`;
  static deleteNote(noteId: number) {
    return `${Urls.baseUri}Notes/NoteId/${noteId}`;
  }
  static createUserAccessRequest: string = `${Urls.baseUri}UserAccessRequests/Create`;
  static allowUserAccessRequest: string = `${Urls.baseUri}UserAccessRequests/Process`;

  static getAllStations: string = `${Urls.baseUri}Stations/GetAll`;
  static getAllSda: string = `${Urls.baseUri}Stations/AllSda`;
  static getAllLso: string = `${Urls.baseUri}Stations/AllLso`;
  static getVisitStatusCounts: string = `${Urls.baseUri}Dashboard/GetVisitStatusCounts`;
  static getVisitsByPremisesType: string = `${Urls.baseUri}Dashboard/GetVisitsByPremisesType`;
  static getReferralsByPartner: string = `${Urls.baseUri}Dashboard/GetReferralsByPartner`;

  static getWatches: string = `${Urls.baseUri}Watch`;
  static getTimeframes: string = `${Urls.baseUri}Timeframe`;

  static getAllTitles: string = `${Urls.baseUri}Titles/GetAll`;
  static getAllHeardFromSources: string = `${Urls.baseUri}HeardFromSources/GetAll`;
  static getAllContactPreferences: string = `${Urls.baseUri}PreferredContactMethods/GetAll`;
  static getAllPreferredContacts: string = `${Urls.baseUri}PreferredContacts/GetPreferredContacts`;
  static getAllPreferredContactRelationshipTypes: string = `${Urls.baseUri}PreferredContacts/GetAllPreferredContactRelationshipTypes`;

  static getAllLocalAuthorities(includeUnknownOption: boolean): string {
    return `${Urls.baseUri}Premises/LocalAuthorities/${includeUnknownOption}`;
  }
  static getAllHousingAssociations(includeUnknownOption: boolean): string {
    return `${Urls.baseUri}Premises/HousingAssociations/${includeUnknownOption}`;
  }

  static getPartnerById(partnerId: number): string {
    return `${Urls.baseUri}Partners/GetPartnerById/${partnerId}`;
  }

  static resendNotification(visitId: number) {
    return `${Urls.baseUri}Notification/ResendNotification/${visitId}`;
  }

  static recordNotificationSent(visitId: number, preferredContactMethodId?: number) {
    if (preferredContactMethodId) {
      return `${Urls.baseUri}Notification/RecordNotificationSent/${visitId}/${preferredContactMethodId}`;
    } else {
      return `${Urls.baseUri}Notification/RecordNotificationSent/${visitId}`;
    }
  }

  static generateLetter(visitId: number) {
    return `${Urls.baseUri}Notification/GenerateLetter/${visitId}`;
  }

  static generateRevisitNotificationLetters(ticks: number) {
    return `${Urls.baseUri}Notification/GenerateRevisitNotificationLetters/${ticks}`;
  }

  static getDuplicateReferrals() {
    return `${Urls.baseUri}Visits/DuplicateReferrals`;
  }

  static getDuplicateReferralsByPremisesId(premisesId: number) {
    return `${Urls.baseUri}Visits/DuplicateReferralsByPremisesId/${premisesId}`;
  }

  static deleteVisitAction(visitId: number, visitActionId: number, visitActionDeletionReasonId: number) {
    return `${Urls.baseUri}VisitActions/DeleteVisitAction/${visitId}/${visitActionId}/${visitActionDeletionReasonId}`;
  }

  static getPartnerByEmail(email: string): string {
    return `${Urls.baseUri}partners/GetByEmail/${email}`;
  }

  static getLocalAuthorityByEastingNorthing(easting: number, northing: number): string {
    return `${Urls.baseUri}premises/GetLocalAuthorityByEastingNorthing/${easting}/${northing}`;
  }

  //GetLocalAuthorityByEastingNorthing
  static getReferralsForPartners: string = `${Urls.baseUri}partners/GetReferralsForPartners`;
  static getAllReferralDeclineReasons: string = `${Urls.baseUri}partners/GetAllReferralDeclineReasons`;
}
